/**
 * Loads the signed-in user's theme from the BFF and applies it via ThemeContext.
 *
 * The theme is personal rather than workspace-scoped, so this resolves to the same
 * value in every workspace; it runs per workspace only to seed a fresh session.
 */

import { PersonalDashboardPreferencesClient } from "@/api/personalDashboardPreferencesApi";

export class WorkspaceThemePreferencesLoader {
  constructor(client = new PersonalDashboardPreferencesClient()) {
    this._client = client;
    this._seq = 0;
  }

  /**
   * @param {(theme: "light" | "dark" | "system") => void} applyTheme
   * @returns {Promise<void>}
   */
  async loadAndApply(applyTheme) {
    const seq = (this._seq += 1);
    try {
      const prefs = await this._client.get();
      // A later workspace started loading while this request was in flight;
      // applying now would paint the previous workspace's theme.
      if (seq !== this._seq) return;
      if (prefs.theme) {
        applyTheme(prefs.theme);
      }
    } catch {
      /* fall back to local ThemeContext / localStorage */
    }
  }
}
